<template>
    <div v-show="showLoader" class="loader"><img src="../../../assets/images/loader.gif" alt=""></div>  
    <!--  Main Start Here  -->
    <main class="main_content">
      <!-- Page Title -->
      <div class="row mb-4 align-items-center">
            <div class="col-md-8">
            <h2 class="page_title">Purchase Order</h2>
            </div>
            <!-- <div class="col-md-4">
                    <div class="top_btns">
                        <a @click="create_inquiry" class="btn btn-primary">Create Inquiry</a>
                    </div>
            </div> -->
      </div>
      <div class="filter-buttons-tab">
        <button class="tabs-btn" v-bind:class="{active: (buttonState == 'New')}" v-on:click="tabButtonClicked( $event )" data-val='12'>New</button>
        <button class="tabs-btn" v-bind:class="{active: (buttonState == 'Active')}" v-on:click="tabButtonClicked( $event )" data-val='14,15,17,18,19,20,21'>Active</button>
        <button class="tabs-btn" v-bind:class="{active: (buttonState == 'Archived')}" v-on:click="tabButtonClicked( $event )" data-val='13,16'>Archived</button>
      </div>
      <div class="card_box">
        <div class="table_listing">
          <div class="custom_search">
              <div class="row mx-0">
                <!-- <div class="col">
                    <input type="text" name="po_id" class="search_input" placeholder="PO #" id="po_id" autocomplete="off">
                </div>
                <div class="col">
                    <input type="text" name="rfq_id" class="search_input" placeholder="Quotation #" id="rfq_id" autocomplete="off">
                </div>
                <div class="col">
                    <datepicker inputFormat="dd-MM-yyyy" class="search_input datepicker_input" placeholder="From" autocomplete="off" v-model="from_date" id="from_date" :clearable="true"/>
                </div>
                <div class="col">
                    <datepicker inputFormat="dd-MM-yyyy" class="search_input datepicker_input" placeholder="To" autocomplete="off" v-model="to_date" id="to_date"  :clearable="true"/>
                </div> -->

                <div class="col">
                    <div class="form-outline">
                        <input type="text" name="po_id" class="form-control" :class="{ 'active' : po_id }" id="po_id" v-model="po_id" >
                        <label class="form-label" for="po_id">PO ID</label>
                    </div>
                </div>

                <div class="col">
                    <div class="form-outline">
                        <input type="text" name="rfq_id" class="form-control" :class="{ 'active' : rfq_id }" id="rfq_id" v-model="rfq_id">
                        <label class="form-label" for="rfq_id">Quote ID</label>
                    </div>
                </div>
                
                <div class="col">
                    <div class="form-outline" >
                        <div :class="{ 'active': from_date }">
                            <datepicker inputFormat="dd-MM-yyyy" class="form-control" v-model="from_date" id="from_date" :clearable="true"/>
                            <label class="form-label" for="from_date">From Date</label>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="form-outline" >
                        <div :class="{ 'active': to_date }">
                            <datepicker inputFormat="dd-MM-yyyy" class="form-control" v-model="to_date" id="to_date"  :clearable="true"/>
                            <label class="form-label" for="to_date">To Date</label>
                        </div>
                    </div>
                </div>
                <div class="col">
                   <button type="submit" v-on:click="searchButtonClicked" class="search_btn" id="search">Search</button>
                </div>
              </div>
          </div>
          <table id="pos" class="table display" style="width:100%">
            <thead>
              <tr>
                <th>PO ID</th>
                <th>Quote ID</th>
                <th>Status</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            
        </table>
        </div>
      </div>
    </main>
</template>
<script>
import $ from "jquery";

import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import Datepicker from 'vue3-datepicker'
import "jszip";
export default {
  components: {
    Datepicker
  },
  data(){
    return{
        showLoader: false,
        buttonState: 'New',
        from_date: '',
        to_date: '',
        po_id: '',
        rfq_id: '',
        active: false,
        API_URL: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    currentUser() {
        return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {

    if (!this.currentUser) {
      this.$router.push('/login');
    } else {
      this.getPOs();
    }

  },
  methods: {
    logOut() {
        this.$store.dispatch('auth/logout');
        this.$router.push('/login');
    },
    searchButtonClicked() {

      this.$nextTick (() => { // wait until data fully updated before re-render new DOM 

        $('#pos').DataTable().draw();

      });
      
    },
    tabButtonClicked( e ) {

      var obj = e.target;
      this.buttonState = obj.textContent;
      this.showLoader = true;

      this.$nextTick (() => { // wait until data fully updated before re-render new DOM 

        $('#pos').DataTable().draw();

      });

      this.showLoader = false;

    },
    getPOs() {

      var access_token = this.currentUser.accessToken;
      $('#pos').DataTable({
          deferRender: true,
          sDom: 'rtilfp',
          aaSorting: [],
          bFilter: false,
          serverSide: true,
          processing: true,
          loading:true,
          bLengthChange: true,
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"]
          ],
          ajax: {
            url: this.API_URL + "supplier/po",
            type: "POST",
            data: function ( d ) {
                d.rfq_id = $("#rfq_id").val();
                d.po_id = $("#po_id").val();
                d.from_date = $("#from_date").val();
                d.to_date = $("#to_date").val();
                d.status = $(".tabs-btn.active").data('val');
                d.api_token = access_token;
            },
          },
          columns: [
            { data: "id" },
            { data: "rfq_id" },
            { data: "status_html" },
            { data: "created_at" },
            { data: "actions" }
          ],
          columnDefs: [
            /*{ className: "status_html", "targets": [ 2 ], orderable: false },*/
            { className: "actions", "targets": [ 4 ], orderable: false },
          ],
        });

        $('#pos').DataTable().on('preXhr.dt', function (e, settings, data) {
          // this.showLoader = true;
          for (let i = 0; i < data.order.length; i++) {
              var col = data.order[i].column;
              var dir = data.order[i].dir;
              data.order_by = data.columns[col].data;
              data.order_dir = dir;
          }
        });

        // $("#rfqs").DataTable({
        //         processing: true,
        //         sDom: 'rtilfp',
        //         bFilter: false,
        //     serverSide: true,
        //     retrieve: true,
        //     aaSorting: [],
        //     ajax: { 'data':{'api_token': access_token},type: 'POST', url: this.API_URL + "supplier/po"  },
        //     buttons: ["colvis", "excel", "print", "csv"],
        //     columns: [
        //         { data: "po_id" },
        //         { data: "rfq_id" },
        //         { data: "status" },
        //         { data: "created_at" },
        //         { data: "action" }
        //     ],
        //     "lengthMenu": [[25, 50, 75, 100, -1], [25, 50, 75, 100, "All"]],
        //     rowReorder: {
        //         selector: 'tr td:not(:first-of-type,:last-of-type)',
        //         dataSrc: 'position'
        //     },
        // });

    },
  },
};
</script>